import { render, staticRenderFns } from "./Footer2.vue?vue&type=template&id=4e268f96&scoped=true&"
import script from "./Footer2.vue?vue&type=script&lang=js&"
export * from "./Footer2.vue?vue&type=script&lang=js&"
import style0 from "./Footer2.vue?vue&type=style&index=0&id=4e268f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e268f96",
  null
  
)

component.options.__file = "Footer2.vue"
export default component.exports